import { render, staticRenderFns } from "./LogisticDropdown.vue?vue&type=template&id=00864196&"
import script from "./LogisticDropdown.vue?vue&type=script&lang=js&"
export * from "./LogisticDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports